<template>
  <p style="font-size: 18px; font-weight: 700; padding: 20px 240px 0 20px; text-align: right">Time remaining：{{ hour }}:{{ minute }}:{{ second }}</p>
</template>

<script>
export default {
  name: "Counter",
  data() {
    return {
      data_hours: this.getNum("hours", this.hours),
      data_minutes: this.getNum("minutes", this.minutes),
      data_seconds: this.getNum("seconds", this.seconds),
    };
  },
  props: {
    hours: {
      type: Number,
      default: 0,
    },
    minutes: {
      type: Number,
      default: 0,
    },
    seconds: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    // 监听数值变化
    second: {
      handler(newVal) {
        this.num(newVal);
      },
    },
    minute: {
      handler(newVal) {
        this.num(newVal);
      },
    },
    hour: {
      handler(newVal) {
        this.num(newVal);
      },
    },
  },
  computed: {
    // 初始化数据
    second() {
      return this.num(this.data_seconds);
    },
    minute() {
      return this.num(this.data_minutes);
    },
    hour() {
      return this.num(this.data_hours);
    },
  },
  mounted() {
    console.log("mounted...");
    console.log(this.getNum("hours", 0), this.getNum("minutes", 0), this.getNum("seconds", 0));
    this.countDown();
  },
  methods: {
    num(n) {
      return n < 10 ? "0" + n : "" + n;
    },
    countDown() {
      let time = window.setInterval(() => {
        if (this.data_hours !== 0 && this.data_minutes === 0 && this.data_seconds === 0) {
          this.data_hours -= 1;
          this.data_minutes = 59;
          this.data_seconds = 59;
        } else if (this.data_hours === 0 && this.data_minutes !== 0 && this.data_seconds === 0) {
          this.data_minutes -= 1;
          this.data_seconds = 59;
        } else if (this.data_hours === 0 && this.data_minutes === 0 && this.data_seconds === 0) {
          window.clearInterval(time);
          this.$emit("onCountDownEnd");
        } else if (this.data_hours !== 0 && this.data_minutes !== 0 && this.data_seconds === 0) {
          this.data_minutes -= 1;
          this.data_seconds = 59;
        } else {
          this.data_seconds -= 1;
        }
        this.setNum("hours", this.data_hours);
        this.setNum("minutes", this.data_minutes);
        this.setNum("seconds", this.data_seconds);
      }, 1000);
    },
    setNum(key, num) {
      localStorage.setItem(key, num.toString());
    },
    getNum(key, num) {
      if (localStorage.getItem(key) !== null) {
        return parseInt(localStorage.getItem(key));
      } else {
        return num;
      }
    },
  },
};
</script>

<style>
</style>